import { useMemo, useState, useCallback } from 'react'

import { filterBookings, defaultFilters, type BookingsFilters } from '../data/bookingFilters'
import { useBookingsState } from '../context/BookingsContext'

/**
 * Consumes the global bookings state and maintains the filter state for the My Bookings page.
 */
export const useBookings = () => {
  const {
    records,
    isLoading,
    error,
    addBooking,
    updateBooking,
    setTripStatus,
    assignDriver,
    removeDriver,
    togglePayment,
    removeBooking,
    notifyCustomer,
  } = useBookingsState()

  const [filters, setFilters] = useState<BookingsFilters>(defaultFilters)

  const visible = useMemo(() => filterBookings(records, filters), [records, filters])
  const resetFilters = useCallback(() => setFilters(defaultFilters), [])

  return {
    records,
    visible,
    filters,
    isLoading,
    error,
    addBooking,
    updateBooking,
    setFilters,
    resetFilters,
    setTripStatus,
    assignDriver,
    removeDriver,
    togglePayment,
    removeBooking,
    notifyCustomer,
  }
}
